module.exports = __webpack_public_path__ + "img/pix.e14181f6.svg";